import React, { useState, useEffect, useContext } from "react";
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";

const SnackBar = ({
  open,
  setOpen,
  type,
  message,
  verticalPosition,
  horizontalPosition,
}) => {
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{
        vertical: verticalPosition,
        horizontal: horizontalPosition,
      }}
      autoHideDuration={3000}
      onClose={handleClose}
    >
      <Alert severity={type}>{message}</Alert>
    </Snackbar>
  );
};

export default SnackBar;
